import { render, staticRenderFns } from "./AddProductToProjectModal.vue?vue&type=template&id=2ec31ba0&"
import script from "./AddProductToProjectModal.vue?vue&type=script&lang=js&"
export * from "./AddProductToProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports